module.exports = __webpack_public_path__ + "static/media/stamp.4117fa9c.png";